import { useMemo } from "react";
import type { FacetFiltersState } from "../../../hooks/useFacetFilters";
import { FilterFieldList } from "./FilterFieldList";
import { FilterSidebar } from "./FilterSidebar";
import { buildFacetSections, type FacetSpec } from "./facetSections";

type FacetFilterRailProps<T> = {
	/** Unfiltered rows. */
	rows: readonly T[];
	facets: readonly FacetSpec<T>[];
	filters: FacetFiltersState<T>;
	collapsed: boolean;
	onCollapsedChange: (collapsed: boolean) => void;
	dataTestId: string;
};

/** A left filter rail of facet groups with live counts, for a `FilterRailFrame`. */
export const FacetFilterRail = <T,>({ rows, facets, filters, collapsed, onCollapsedChange, dataTestId }: FacetFilterRailProps<T>) => {
	const sections = useMemo(
		() =>
			buildFacetSections({
				rows,
				facets,
				result: filters.result,
				selection: filters.selection,
				onToggle: filters.toggle,
				highlightedId: filters.highlightedId,
				dataTestId,
			}),
		[rows, facets, filters.result, filters.selection, filters.toggle, filters.highlightedId, dataTestId],
	);
	return (
		<FilterSidebar
			collapsed={collapsed}
			onCollapsedChange={onCollapsedChange}
			collapsedVariant="rail"
			frame="flush"
			activeFilterCount={filters.activeCount}
			onClearAll={filters.clear}
			dataTestId={`${dataTestId}-sidebar`}
		>
			<FilterFieldList sections={sections} dividers dataTestId={dataTestId} />
		</FilterSidebar>
	);
};
